import React from 'react'

const UserInvitationTemplate = ({ template, user, urlMapper }) => (
  <div className="list-group-item d-flex align-items-center resend-invitation">
    <div className="preview flex-grow-1">
      <div className="description">
        Resend Customer Invitation
        { template.attributes.eventType == "send_email" && <span className="badge bg-primary ms-1">Email</span> }
      </div>
      <div className="text-muted">To: { user.attributes.email }</div>
      <div className="text-muted">Subject: { template.attributes.subject }</div>
    </div>
    <div className="ms-3 action-buttons">
      <a href={urlMapper.resendInvitationUrl(user.id)} data-method="put" data-confirm="Do you want to send this message?" className="btn btn-secondary">Send Now</a>
    </div>
  </div>
)

export default UserInvitationTemplate
